import React, { Component } from "react";
import { connect } from "react-redux";
import * as R from "ramda";
import FlexView from "react-flexview";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import CashCreditCompositionReport from "./cashCreditCompositionReport";
import FincoyCompositionReport from "./fincoyCompositionReport";
import FincoyGrowthReport from "./fincoyGrowthReport";
import FincoyContributionReport from "./fincoyContributionReport";
import { fetchDataAsync } from "../../../../../Services/Utils";
import Api from "../../../../../Services/Api";
import Container from "../../../../../modules/commons/Container";
import SimpleCheckBox from "../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import { mapToObjectDDL } from "../../../../common/mapper";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import * as ErrorAction from "../../../../../Redux/ErrorRedux";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";

class KacabReportBySalesComposition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllSelected: true,
      isSpecificSelected: false,
      dataCabang: [],
      kodeCabang: [],
      search: [],
      loading: false,
    };
  }

  componentDidMount = async () => {
    await this.fetchDataCabang();
    this.fetchLeaderId();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (R.isNil(this.state.kodeCabang)) {
      this.setState((prevValue) => ({
        ...prevValue,
        kodeCabang: [],
      }));
    }
  }

  fetchLeaderId = async () => {
    const idLeader = localStorage.getItem("idLeader");
    const userId = localStorage.getItem("userId");

    if (idLeader) {
      this.setState((prevValue) => ({
        ...prevValue,
        idLeader: idLeader,
      }));
      return;
    }
    this.handleTriggerLoading();
    try {
      let res = await fetchDataAsync({
        asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
        setError: this.props.setError,
      });
      console.log(res);

      if (res.ok) {
        localStorage.setItem("idLeader", res.data.data.id);
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: res.data.data.id,
        }));
      }
    } catch (error) {
      console.log("errors: ", error);
    }
    this.handleTriggerLoading();
  };

  fetchDataCabang = async () => {
    try {
      let res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
        setError: this.props.setError,
        menuName:
          "Dashboard Level Kepala Cabang Keatas - Laporan Sales Composition",
        args: null,
      });
      if (res.ok) {
        let filteredData = res.data.data.filter((item) =>
          this.props.menuAccess
            .map((data) => data.idRefObj)
            .includes(item.kodeCabang),
        );

        if (filteredData.length !== 0) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataCabang: filteredData,
            search: ["ALL"],
          }));
        }
      }
    } catch (error) {
      console.log("errors", error);
    }
  };

  handleSelectCabang = (e, type) => {
    const isChecked = e.target.checked;

    if (type === "ALL") {
      this.setState((prevValue) => ({
        ...prevValue,
        isAllSelected: isChecked,
        isSpecificSelected: false,
        kodeCabang: [],
      }));
    }

    if (type === "SPECIFIC") {
      this.setState((prevValue) => ({
        ...prevValue,
        isSpecificSelected: isChecked,
        isAllSelected: false,
        kodeCabang: [],
      }));
    }
  };

  handleSearch = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      search: this.state.isAllSelected
        ? ["ALL"]
        : this.state.isSpecificSelected && !R.isEmpty(this.state.kodeCabang)
          ? this.state.kodeCabang.map((item) => item.value)
          : [],
    }));
  };

  handleChangeCabang = (value) => {
    this.setState((prevValue) => ({ ...prevValue, kodeCabang: value }));
  };

  handleTriggerLoading = () => {
    this.setState((prevValue) => ({
      ...prevValue,
      loading: !prevValue.loading,
    }));
  };

  render() {
    return (
      <>
        <Container>
          <FlexView style={{ gap: "20px", alignItems: "center" }}>
            <SimpleCheckBox
              id="reportAllCabang"
              key="reportAllCabang"
              name="reportAllCabang"
              label="ALL CABANG"
              checked={this.state.isAllSelected}
              onChange={(e) => this.handleSelectCabang(e, "ALL")}
            />
            <SimpleCheckBox
              id="reportSpecificCabang"
              key="reportSpecificCabang"
              name="reportSpecificCabang"
              label="SPESIFIK CABANG"
              checked={this.state.isSpecificSelected}
              onChange={(e) => this.handleSelectCabang(e, "SPECIFIC")}
            />
            <SimpleDDL
              id="select_options_kode_cabang"
              box="multiselect"
              name="kodeCabang"
              isClearable
              containerclassname="width width-500px margin-top-15px"
              placeholder="Nama Cabang"
              readOnly={!this.state.isSpecificSelected}
              options={this.state.dataCabang.map((item) =>
                mapToObjectDDL(item.namaDealer, item.kodeCabang),
              )}
              value={this.state.kodeCabang}
              onChange={(value) => this.handleChangeCabang(value)}
            />
            <SimpleButton
              // styles={{marginBottom: "20px"}}
              onClick={this.handleSearch}
            >
              Cari
            </SimpleButton>
          </FlexView>
          <Tabs>
            <TabList>
              <Tab>Laporan Komposisi Cash - Credit Year To Date</Tab>
              <Tab>Laporan Komposisi Cash - Credit 3 Tahun Terakhir</Tab>
              <Tab>Laporan Komposisi Fincoy Year To Date</Tab>
              <Tab>Laporan Komposisi Fincoy 3 Tahun Terakhir</Tab>
              <Tab>
                Laporan Komposisi Growth Fincoy Month To Date Per Cabang
              </Tab>
              <Tab>
                Laporan Komposisi Kontribusi Fincoy Per Cabang 3 Tahun Terakhir
              </Tab>
            </TabList>
            <TabPanel>
              <CashCreditCompositionReport
                {...this.props}
                tab="mtd"
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <CashCreditCompositionReport
                {...this.props}
                tab="l3y"
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <FincoyCompositionReport
                {...this.props}
                tab="mtd"
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <FincoyCompositionReport
                {...this.props}
                tab="l3y"
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <FincoyGrowthReport
                {...this.props}
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
            <TabPanel>
              <FincoyContributionReport
                {...this.props}
                dataCabang={this.state.dataCabang}
                kodeCabang={this.state.kodeCabang}
                search={this.state.search}
                handleTriggerLoading={this.handleTriggerLoading}
                isAllSelected={this.state.isAllSelected}
                idLeader={this.state.idLeader}
              />
            </TabPanel>
          </Tabs>
          {this.state.loading && (
            <SimpleLoadingOverlay active={this.state.loading} />
          )}
        </Container>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(KacabReportBySalesComposition);
